import { render, staticRenderFns } from "./labelDetail.vue?vue&type=template&id=44cafde0&scoped=true"
import script from "./labelDetail.vue?vue&type=script&lang=js"
export * from "./labelDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cafde0",
  null
  
)

export default component.exports